import React, { ReactNode, useCallback, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { Security } from '@okta/okta-react';
import { OktaAuth, toRelativeUrl } from '@okta/okta-auth-js';
import AuthIdentityProvider from './AuthIdentityProvider';
import { useUnmountEffect } from '../../hooks';

type Props = {
  children: ReactNode;
  oktaAuth: OktaAuth;
};

function AuthProvider({ children, oktaAuth }: Props) {
  const navigate = useNavigate();
  const authInstance = useMemo(() => oktaAuth, [oktaAuth]);

  const restoreOriginalUri = useCallback(
    async (_oktaAuth: OktaAuth, originalUri: string) => {
      navigate(toRelativeUrl(originalUri || '/', window.location.origin));
    },
    [navigate]
  );

  // fix for "Two custom restoreOriginalUri callbacks are detected" warning
  useUnmountEffect(() => {
    authInstance.options.restoreOriginalUri = undefined;
  });

  return (
    <Security oktaAuth={authInstance} restoreOriginalUri={restoreOriginalUri}>
      <AuthIdentityProvider>{children}</AuthIdentityProvider>
    </Security>
  );
}

export default AuthProvider;
